import axios from "axios";
import instance from "./helpers/instance";

const corporateHealthService = {
	getTemperatureMetrics,
	getCovidMetrics,
	listQuarantinedEmployees,
	getHealthPass,
	getPartnerDetails,
	getPartnerEmployees,
	getPartnerEmployeesAndReferences,
	listGates,
	assignAsCheckerOrRep,
	updatePartnerCompany,
	getTrafficHistory,
	listIndustries,
	addEmployee,
	getLocation,
	getPartnerLocations,
	getPartnerDepartments,
	getEmployeesByRoleType,
	getEmployeesV2,
	getEmployeeHealthRisk,
	getEmployeeHealthRiskV2,
	getEmployeeHealthRiskUnknown,
	getLinkingRequests,
	getNoMatchLinkingRequests,
	updateLinkingRequest,
	getEmployeeDetails,
	getEmployeeLogs,
	importEmployeeReferences,
	listLocationTypes,
	importHealthCheckers,
	listFloors,
	addLocation,
	updateLocation,
	removeFromQuarantine,
	importLocations,
	clearFromQuarantine,
	unassignHealthChecker,
	listLocationCounts,
	listEligibleEmployeesAsHealthCheckers,
	moveQuarantineCategory,
	getRejectionReasons,
	getCompletedQuarantineEmployees,
	getCompanyRoles,
	getCompanyLogos,
	getCompanyMappings,
	getAllergies,
	getComorbidities,
	getVaccines,
	getHealthPassFromCode,
	acceptInvite,
	getCorporatePass,
	getEventInviteDetailsByCode,
	acceptEventInvite,
	declineEventInvite,
	getRelationOptions,
	getEmployeeTypes,
	getPartnerPrivacy
};

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

async function getPartnerPrivacy(partnerId) {
	return await instance.get(`${API_URL}/api/1/corporate/partners/${partnerId}/privacy/message`)
}

async function getRelationOptions() {
	return await instance.get(`${API_URL}/api/1/corporate/employees/relationships/types`);
}

async function getEmployeeTypes() {
	return await instance.get(`${API_URL}/api/1/corporate/employees/employees/types`);
}

async function getEventInviteDetailsByCode(code) {
	return (
		await axios.get(
			`${API_URL}/api/1/corporate/events/invites/?code=${code}`
		)
	);
}
async function acceptEventInvite(code) {
	return (
		await axios.put(
			`${API_URL}/api/1/corporate/events/invites/accept`,
			{code}
		)
	);
}
async function declineEventInvite(code) {
	return (
		await axios.put(
			`${API_URL}/api/1/corporate/events/invites/decline`,
			{code}
		)
	);
}
async function getHealthPassFromCode(code) {
	return (
		await axios.get(
			`${API_URL}/api/1/corporate/employees/invites/?code=${code}`
		)
	);
}

async function acceptInvite(code, params) {
	return await axios.post(
		`${API_URL}/api/1/corporate/employees/invites/accept`,
		{ ...params, code }
	);
}

async function getCorporatePass(hash_id, affiliation, token) {
	return (
		await axios.get(
			`${API_URL}/api/1/corporate/passes`,
			{ params:{hash_id, affiliation} },
			// {
			// 	headers: {
			// 		"X-Auth-Token": token,
			// 	},
			// }
		)
	)?.data;
}
function getTemperatureMetrics(companyId) {
	return instance
		.get(
			`${API_URL}/api/1/corporate/${companyId}/dashboard/metrics/temperature`,
			{ cache: false }
		)
		.then((response) => {
			return response.data;
		});
}

function getCovidMetrics(companyId) {
	return instance
		.get(`${API_URL}/api/1/corporate/${companyId}/dashboard/metrics/covid`, {
			cache: false,
		})
		.then((response) => {
			return response.data;
		});
}

function listQuarantinedEmployees(companyId, params) {
	return instance
		.get(`${API_URL}/api/1/corporate/${companyId}/quarantine`, {
			params: params,
			cache: false,
		})
		.then((response) => {
			return response.data;
		});
}

function moveQuarantineCategory(companyId, params) {
	return instance
		.put(
			`${API_URL}/api/1/corporate/${companyId}/quarantine/moveCategory`,
			params,
			{ cache: false }
		)
		.then((response) => {
			return response.data;
		});
}

function getPartnerDetails(partnerId) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/${partnerId}/detailed`, {
			cache: false,
		})
		.then((response) => {
			return response.data;
		});
}

function getPartnerEmployees(partnerId, params) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/${partnerId}/employees`, {
			params: params,
			cache: false,
		})
		.then((response) => {
			return response.data;
		});
}

function getPartnerEmployeesAndReferences(partnerId, params) {
	return instance
		.get(`${API_URL}/api/2/corporate/partners/${partnerId}/employees`, {
			params: params,
		})
		.then((response) => {
			return response.data;
		});
}

function getPartnerLocations(partnerId, params) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/${partnerId}/locations`, {
			params: params,
			cache: false,
		})
		.then((response) => {
			return response.data;
		});
}

function getPartnerDepartments(partnerId) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/${partnerId}/departments`)
		.then((response) => {
			return response.data;
		});
}

function listLocationTypes() {
	return instance
		.get(`${API_URL}/api/1/corporate/location/types`)
		.then((response) => {
			return response.data;
		});
}

function listGates(partnerId, locationId) {
	return instance
		.get(
			`${API_URL}/api/1/corporate/partners/${partnerId}/locations/${locationId}/gates`
		)
		.then((response) => {
			return response.data;
		});
}

function listFloors(partnerId, locationId) {
	return instance
		.get(
			`${API_URL}/api/1/corporate/partners/${partnerId}/locations/${locationId}/floors`
		)
		.then((response) => {
			return response.data;
		});
}

function updatePartnerCompany(p, partnerId) {
	return instance
		.put(`${API_URL}/api/1/corporate/partners/${partnerId}/update`, p, {
			cache: false,
		})
		.then((response) => {
			return response.data;
		});
}

function assignAsCheckerOrRep(p) {
	return instance
		.post(
			`${API_URL}/api/1/corporate/partners/${p.partner}/employee/locations/${p.location}/setRepsChecker`,
			p,
			{ cache: false }
		)
		.then((response) => {
			return response.data;
		});
}

function getTrafficHistory(locationId, p) {
	p.temp_logic_operator = ">=";
	p.risk_level = true;
	p.recorded_temperature = 38;

	return instance
		.get(
			`${API_URL}/api/1/corporate/traffic/location/${locationId}/getTraffic`,
			{ params: p, cache: false }
		)
		.then((response) => {
			return response.data;
		});
}

function getEmployeesByRoleType(p) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/${p.partner}/employeesV2`, {
			params: p,
			cache: false,
		})
		.then((response) => {
			return response.data;
		});
}

function getCompanyRoles(p) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/${p}/roles`, { cache: false })
		.then((response) => {
			return response.data;
		});
}

function getEmployeesV2(usp) {
	return instance
		.get(
			`${API_URL}/api/1/corporate/partners/${usp.get("partner")}/employeesV2?` +
				usp.toString(),
			{ cache: false }
		)
		.then((response) => {
			return response.data;
		});
}

function getEmployeeHealthRiskV2(params) {
	return instance
		.get(
			`${API_URL}/api/1/corporate/partners/${params.partner}/employees/risks/levels`,
			{ params: params, cache: false }
		)
		.then((response) => {
			return response.data;
		});
}

function getEmployeeHealthRisk(partnerId, params) {
	return instance
		.get(
			`${API_URL}/api/1/corporate/partners/${partnerId}/employees/risks/levels`,
			{ params, cache: false }
		)
		.then((response) => {
			return response.data;
		});
}

function getEmployeeHealthRiskUnknown(partnerId, params) {
	return instance
		.get(
			`${API_URL}/api/1/corporate/partners/${partnerId}/employees/risks/unknown`,
			{ params, cache: false }
		)
		.then((response) => {
			return response.data;
		});
}

function listIndustries() {
	return instance
		.get(`${API_URL}/api/1/corporate/industries`, { cache: false })
		.then((response) => {
			return response.data;
		});
}

function getLocation(locationId, params) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/locations/${locationId}`, {
			params: params,
			cache: false,
		})
		.then((response) => {
			return response.data;
		});
}

function removeFromQuarantine(partnerId, p) {
	return instance
		.delete(`${API_URL}/api/1/corporate/${partnerId}/quarantine`, { params: p })
		.then((response) => {
			return response.data;
		});
}

function clearFromQuarantine(partnerId, p) {
	return instance
		.post(
			`${API_URL}/api/1/corporate/${partnerId}/quarantine/clearance/upload`,
			p
		)
		.then((response) => {
			return response.data;
		});
}

function listEligibleEmployeesAsHealthCheckers(partnerId, p) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/${partnerId}/checkers/eligible`, {
			params: p,
		})
		.then((response) => {
			return response.data;
		});
}

function getRejectionReasons(params) {
	return instance
		.get(`${API_URL}/api/1/corporate/quarantine/clearance/rejectReasons`, {
			params: params,
			cache: false,
		})
		.then((response) => {
			return response.data;
		});
}

function getHealthPass(hashId, timeout) {
	let p = {
		hash_id: hashId,
	};

	return axios
		.create({
			baseUrl: API_URL,
			headers: {
				// "Access-Control-Allow-Origin": "*",
				// "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, PATCH, OPTIONS",
				// "Access-Control-Allow-Credentials": "true",
				// "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
			},
		})
		.get(`${API_URL}/api/1/corporate/passes`, {
			params: p,
			cache: false,
			timeout: timeout || null,
		})
		.then((response) => {
			return response.data;
		});
}

function addEmployee(partnerId, params) {
	return instance
		.post(
			`${API_URL}/api/1/corporate/partners/${partnerId}/employees/references`,
			params
		)
		.then((response) => {
			return response.data;
		});
}

function addLocation(companyId, params) {
	return instance
		.post(`${API_URL}/api/1/corporate/partners/${companyId}/locations`, params)
		.then((response) => {
			return response.data;
		});
}

function unassignHealthChecker(companyId, params) {
	return instance
		.put(
			`${API_URL}/api/1/corporate/partners/${companyId}/employee/${params.employee_id}/unassignAsChecker`,
			params
		)
		.then((response) => {
			return response.data;
		});
}

function listLocationCounts(companyId, params) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/${companyId}/locations/counts`, {
			params: params,
		})
		.then((response) => {
			return response.data;
		});
}

function importLocations(companyId, params) {
	return instance
		.post(`${API_URL}/api/1/corporate/locations/import`, params, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
		.then((response) => {
			return response.data;
		});
}

function importHealthCheckers(companyId, params) {
	return instance
		.post(`${API_URL}/api/1/corporate/checkers/import`, params, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
		.then((response) => {
			return response.data;
		});
}

function updateLocation(params) {
	return instance
		.put(
			`${API_URL}/api/1/corporate/partners/${params.pid}/locations/${params.id}/update`,
			params
		)
		.then((response) => {
			return response.data;
		});
}

function importEmployeeReferences(partnerId, params) {
	return instance
		.post(
			`${API_URL}/api/1/corporate/partners/${partnerId}/employees/csv`,
			params,
			{
				headers: {
					"Content-Type": "multipart/form-data",
				},
			}
		)
		.then((response) => {
			return response.data;
		});
}

function getEmployeeDetails(id) {
	return instance
		.get(`${API_URL}/api/1/corporate/employees/${id}`)
		.then((response) => {
			return response.data;
		});
}

function getEmployeeLogs(partnerId, params) {
	return instance
		.get(`${API_URL}/api/1/corporate/${partnerId}/logs/employees`, { params })
		.then((response) => {
			return response.data;
		});
}

function getLinkingRequests(params) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/link-requests`, {
			params,
			cache: false,
		})
		.then((response) => response.data);
}

function getNoMatchLinkingRequests(params) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/link-requests/noMatch`, {
			params,
			cache: false,
		})
		.then((response) => response.data);
}

function updateLinkingRequest(requestId, params) {
	return instance.put(
		`${API_URL}/api/1/corporate/partners/link-requests/${requestId}`,
		params
	);
}

function reassignHealthChecker(partnerId, checkerId) {}

function getCompletedQuarantineEmployees(companyId, p) {
	return instance
		.get(
			`${API_URL}/api/1/corporate/${companyId}/quarantine/completedDuration`,
			{ params: p, cache: false }
		)
		.then((response) => response.data);
}

function getCompanyLogos(companyId) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/${companyId}/corporateMedia`, {
			cache: false,
		})
		.then((response) => response.data);
}

function getCompanyMappings(companyId) {
	return instance
		.get(`${API_URL}/api/1/corporate/partners/${companyId}/mappings`, {
			cache: false,
		})
		.then((response) => {
			return response.data;
		});
}

async function getAllergies() {
	return await instance.get(`${API_URL}/api/1/corporate/medical/allergies`);
	// const allergies = require('./allergies.json')
	// console.log("📢[corporate-health.service.js:413]:", allergies);
	// return {data:allergies}
}

async function getComorbidities() {
	return await instance.get(`${API_URL}/api/1/corporate/medical/comorbidities`);
	// const comorbidities = require('./comorbities.json')
	// console.log("📢[corporate-health.service.js:420]:", comorbidities);
	// return {data:comorbidities}
}

async function getVaccines() {
	return await instance.get(`${API_URL}/api/1/corporate/medical/vaccines`);
	// const comorbidities = require('./comorbities.json')
	// console.log("📢[corporate-health.service.js:420]:", comorbidities);
	// return {data:comorbidities}
}

export default corporateHealthService;
